import { useEffect, useState } from 'react';
import { getSettings } from '../api.js';
import { parseUnitPref, type UnitPref } from '../lib/units.js';

/**
 * The user's display-unit preference, read once from settings. Defaults to
 * imperial (both while loading and when the `units` setting is unset), matching
 * the server-side default so the UI never flashes the wrong units for the
 * single imperial user.
 */
export function useUnitPref(): UnitPref {
  const [pref, setPref] = useState<UnitPref>('imperial');
  useEffect(() => {
    let alive = true;
    getSettings()
      .then((s) => {
        if (alive) setPref(parseUnitPref(s.units));
      })
      .catch(() => {
        /* keep the imperial default on failure */
      });
    return () => {
      alive = false;
    };
  }, []);
  return pref;
}
